const bannerVideoPlayBtn = document.querySelector('.banner__media__playBtn')
const bannerVideoThumbnail = document.querySelector('.banner__media video + img')
const bannerVideo = document.querySelector('.banner__media video')

if (bannerVideoPlayBtn && bannerVideo) {
  bannerVideoPlayBtn.addEventListener('click', () => {
    bannerVideoThumbnail.classList.add('d-none')

    if (bannerVideoPlayBtn.classList.contains('is-playing')) {
      bannerVideo.pause();
      bannerVideoPlayBtn.classList.remove('is-playing');
    } else {
      bannerVideo.play();
      bannerVideoPlayBtn.classList.add('is-playing');
    }
  })
}
